import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminLoggedIn } from "../utils/session";
import LandingPage from "../pages/LandingPage";

/** `/` — landing when logged out, dashboard when logged in */
export default function RootHome() {
  if (isAdminLoggedIn()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <LandingPage />;
}
